import { categoryList } from '../../api/category'

// initial state
const state = {
	items: [],  // 分类页中的分类列表
	currentItem: null //当前焦点的分类
}

// mutations
const mutations = {
  saveCategoryItems(state, items) {
    state.items = items
  },
  clearCategoryItems(state) {
    state.items = []
    state.currentItem = null
  },
  saveCurrentCategoryItem(state, item) {
    state.currentItem = item
  },
  resetCurrentCategoryItem(state) {
    if (state.items && state.items.length) {
      state.currentItem = state.items[0]
    }
  },
}

// actions 
const actions = {
  fetchCategoryList({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      categoryList(params.shop, params.category, 1, 1000).then((response) => {
        if (response && response.categories) {
          if (response.categories.length) {
            commit('saveCategoryItems', response.categories)
            if (!state.currentItem) {
              commit('saveCurrentCategoryItem', response.categories[0])
            }            
          } else {
            commit('clearCategoryItems')
          }
        }
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/category.js